import React from 'react';
import ExamPageContainer from '../../containers/ExamPageContainer/ExamPageContainer';

const ExamPage: React.FC = () => {
  return <ExamPageContainer />;
};

export default ExamPage;
